import { useEffect } from 'react';

import { useUserActionsAnalytics } from '@app/hooks';

export const useIntelligentReminderAnalytics = () => {
  const { trackIntelligentReminderStarted } = useUserActionsAnalytics();

  useEffect(() => {
    trackIntelligentReminderStarted();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
